import React, { useRef } from 'react';
import { Row, Col } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import 'bootstrap/dist/css/bootstrap.min.css';
import Head from '../../components/navbar/Head.js';
import NavBar from '../../components/navbar/NavBar.js';
import Card from 'react-bootstrap/Card';
import { useState, useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import TagsInput from 'react-tagsinput'
import 'react-tagsinput/react-tagsinput.css'
import { isNumeric, isLength } from 'validator';
import { 
    getPublisher, 
    uploadPdfEbook, 
    uploadFileEbook, 
    uploadEpubEbook, 
    uploadEpubSampleEbook, 
    getEbookPrice, 
    getEbookCategory, 
    getEbookItems, 
    editEbookDetails, 
    getPublisherTag, 
    getPublisherKeyword, 
    getEbookSerie, 
    updateEbookPDFPath, 
    updateEbookCoverPath,
    updateEbookEpubFileStatus,
    updateEbookEpubSampleFileStatus
    } from '../../api/index.js'
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import accessPath from '../../api/index.js';
import Spinner from 'react-bootstrap/Spinner';

import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { Alert } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { dialogConfirmSetData, dialogConfirmSetShowModal } from '../../actions/confirmDialog.action.js';

import ImageWithPlaceholder from '../../components/ImageWithPlaceholder/index.js';
import placeholderImg from '../../image/placeHolder_cover.png';    

const EditEbooks = () => {

    const [selectedPublishDateTime, setSelectedPublishDateTime] = useState(dayjs());
    const handleDateChange = (newValue) => {
        setSelectedPublishDateTime(newValue);
     };

    const navigate = useNavigate();
    const location = useLocation();
    const { ebookDetailsID , searchKeyword , searchOption } = location.state || {};
    const [checkButtonLoading, setCheckButtonLoading] = useState('1');
    const [showAlertError, setShowAlertError] = useState(false);
    const [showUploadImageErrorMessage, setUploadImageErrorMessage] = useState('');
    const [showUploadPdfErrorMessage, setUploadPdfErrorMessage] = useState('');
    const dispatch = useDispatch();
    const uploadImageRef = useRef();
    const uploadPDFRef = useRef();
    const uploadEpubRef = useRef();
    const uploadSampleEpubRef = useRef();
    const [rightToLeft, setRightToLeft] = useState('0');
    const refSynopsis = useRef();
    const refIsbn = useRef();
    const refIsbnEbook = useRef();
    const refNote = useRef();

    const [tags, setTags] = useState([]);

    const handleTagsChange = (tags) => {
        setTags(tags);
    };

    const handleChangeRightToLeft = () => {
        const newValue = rightToLeft === '1' ? '0' : '1';
        setRightToLeft(newValue);
    }
    
    const [Keywords, setKeywords] = useState([]);

    const handleKeywords = (tags) => {
        setKeywords(tags)
    };

    const customPlaceholder = 'Add a keywords';

    const [uploadEBook, setUploadEBook] = useState('');
    const [uploadEBookName, setUploadEBookName] = useState('');
    const [selectedFileCoverImage, setSelectedFileEbook] = useState(null);
    const [selectedPdf, setSelectedPdf] = useState(null);
    const [selectedPdfName, setSelectedPdfName] = useState(null);
    const [selectedEpub, setSelectedEpub] = useState(null);
    const [selectedEpubName, setSelectedEpubName] = useState(null);
    const [selectedSampleEpub, setSelectedSampleEpub] = useState(null);
    const [selectedSampleEpubName, setSelectedSampleEpubName] = useState(null);
    
    // State to track files that user has deleted (should be treated as non-existent)
    const [deletedPdf, setDeletedPdf] = useState(false);
    const [deletedEpub, setDeletedEpub] = useState(false);
    const [deletedSampleEpub, setDeletedSampleEpub] = useState(false);
    
    const [textareaError, setTextareaError] = useState('');
    const [CoverPriceError, setCoverPriceError] = useState('');
    const [selectedOnlyOver, setOnlyOver] = useState('');
    const [publishOption, setPublishOption] = useState('as_review_pass');
    const [optionsgetEbookCategory, setOptionsgetEbookCategory] = useState([]);
    const [datagetEbookDetails, setgetEbookDetails] = useState([]);
    const [getPublisherKeywords, setgetPublisherKeyword] = useState([]);
    const [getPublisherTags, setgetPublisherTag] = useState([]);
    const [getEbookSeries, setgetEbookSerie] = useState([]);
    const [otherSeries, setOtherSeries] = useState('');
    const [typeReader, setTypeReader] = useState('both');
    const [PricingAndSales, setPricingAndSales] = useState('');
    const [optionsgetEbookPrice, setOptionsgetEbookPrice] = useState([]);

    const handleImageChange = (event) => {
        const acceptedTypes = ["image/jpeg", "image/jpg"];
        const file = event.target.files[0];

        if (!acceptedTypes.includes(file.type)) {
            // alert("ไฟล์รูปภาพต้องเป็น .jpg, .jpeg, หรือ .png เท่านั้น");
            dispatch(dialogConfirmSetData({
                title: "Error",
                message: "Supported file extensions .jpg .jpeg only",
                closeButton: "",
                confirmButton: "OK",
                eventConfirmButton: () => null,
                eventCloseButton: () => null,
                showCloseButton: false
            }));
            // ** ทำให้ dialog โชว์ขึ้นมา **
            dispatch(dialogConfirmSetShowModal(true));
            // เคลียร์ input
            uploadImageRef.current.value = null;
            return;
        }

        setSelectedFileEbook(file);
        setUploadEBook(URL.createObjectURL(file));
        setUploadEBookName(file.name);
    };

    const handlePdfChange = (event) => {
        if(event.target.files.length === 0) {
            setSelectedPdfName(null);
            setDeletedPdf(false); // Reset deletion flag
            return;
        }
        const file = event.target.files[0];
        const fileType = file.type;
        const fileName = file.name.toLowerCase();
        
        // Accept PDF, EPUB, and INDD files
        const acceptedTypes = [
            "application/pdf"
        ];
        
        const acceptedExtensions = [".pdf"];
        const hasValidExtension = acceptedExtensions.some(ext => fileName.endsWith(ext));

        if (!acceptedTypes.includes(fileType) && !hasValidExtension) {
            dispatch(dialogConfirmSetData({
                title: "Error",
                message: "Supported file extension .pdf only",
                closeButton: "",
                confirmButton: "OK",
                eventConfirmButton: () => null,
                eventCloseButton: () => null,
                showCloseButton: false
            }));
            // ** ทำให้ dialog โชว์ขึ้นมา **
            dispatch(dialogConfirmSetShowModal(true));
            // เคลียร์ input
            uploadPDFRef.current.value = null;
          return;
        }
        setSelectedPdfName(file);
        setDeletedPdf(false); // Reset deletion flag when new file selected
    };

    const handleEpubChange = (event) => {
        if(event.target.files.length === 0) {
            setSelectedEpubName(null);
            setDeletedEpub(false); // Reset deletion flag
            return;
        }
        const file = event.target.files[0];
        const fileType = file.type;
        const fileName = file.name.toLowerCase();
        
        // Accept PDF, EPUB, and INDD files
        const acceptedTypes = [
            "application/epub+zip",
            // "application/x-indesign"
        ];
        
        const acceptedExtensions = [".epub"];
        const hasValidExtension = acceptedExtensions.some(ext => fileName.endsWith(ext));

        if (!acceptedTypes.includes(fileType) && !hasValidExtension) {
            dispatch(dialogConfirmSetData({
                title: "Error",
                message: "Supported file extensions: .epub",
                closeButton: "",
                confirmButton: "OK",
                eventConfirmButton: () => null,
                eventCloseButton: () => null,
                showCloseButton: false
            }));
            // ** ทำให้ dialog โชว์ขึ้นมา **
            dispatch(dialogConfirmSetShowModal(true));
            // เคลียร์ input
            uploadEpubRef.current.value = null;
          return;
        }
        setSelectedEpubName(file);
        setDeletedEpub(false); // Reset deletion flag when new file selected
    };

    const handleSampleEpubChange = (event) => {
        if(event.target.files.length === 0) {
            setSelectedSampleEpubName(null);
            setDeletedSampleEpub(false); // Reset deletion flag
            return;
        }
        const file = event.target.files[0];
        const fileType = file.type;
        const fileName = file.name.toLowerCase();
        
        // Accept PDF, EPUB, and INDD files
        const acceptedTypes = [
            "application/epub+zip",
            // "application/x-indesign"
        ];
        
        const acceptedExtensions = [".epub"];
        const hasValidExtension = acceptedExtensions.some(ext => fileName.endsWith(ext));

        if (!acceptedTypes.includes(fileType) && !hasValidExtension) {
            dispatch(dialogConfirmSetData({
                title: "Error",
                message: "Supported file extensions: .epub",
                closeButton: "",
                confirmButton: "OK",
                eventConfirmButton: () => null,
                eventCloseButton: () => null,
                showCloseButton: false
            }));
            // ** ทำให้ dialog โชว์ขึ้นมา **
            dispatch(dialogConfirmSetShowModal(true));
            // เคลียร์ input
            uploadSampleEpubRef.current.value = null;
          return;
        }
        setSelectedSampleEpubName(file);
        setDeletedSampleEpub(false); // Reset deletion flag when new file selected
    };

    const handleBackClick = () => {
        navigate('/ManageBooks', {
            replace: true , 
            state: {
                searchKeyword: searchKeyword || '',
                searchOption: searchOption || ''
            }
        
        });
    };

    const handleChange = (event) => {
        const { name, value } = event.target || '';
        setFormData((prevData) => ({ ...prevData, [name]: value }));

        if (name === 'paperCoverPrice') {
            if (!isNumeric(value)) {
                setCoverPriceError('');
            } else if (!isLength(value, { min: 1, max: 5 })) {
                setCoverPriceError('');
            } else {
                setCoverPriceError('');
            }
        }

        if (name === 'noteTeam') {
            if (!isLength(value, { min: 0, max: 300 })) {
                setTextareaError('Please enter 300 digits');
            } else {
                setTextareaError('');
            }

        } 
    }

    const handleChangeOnlyOver = () => {
        const newValue = selectedOnlyOver === '1' ? '0' : '1';
        setOnlyOver(newValue);
    };
    
    const handlePricingAndSales = (event) => {
        setPricingAndSales(event.target.value);
    };

    const handleStatus = (event) => {
        setPublishOption(event.target.value);
    };

    //Get ราคา EbookPrice
    function showEbookPrice() {
        getEbookPrice().then(handleShowEbookPrice)
    }
    const handleShowEbookPrice = async (response) => {
        setOptionsgetEbookPrice(response.data);
    }

    //getEbookCategory
    function showEbookCategory() {
        getEbookCategory().then(handleShowEbookCategory)
    }
    const handleShowEbookCategory = async (response) => {
        setOptionsgetEbookCategory(response.data);
    }

    function showEbookDetails() {
        getEbookItems(ebookDetailsID).then(handleShowEbookDetails)
    }

    //getPublisherKeyword
    function showGetPublisherKeyword() {
        getPublisherKeyword().then(handleshowGetPublisherKeyword)
    }
    const handleshowGetPublisherKeyword = async (response) => {
        setgetPublisherKeyword(response.data);
    }

    //getPublisherTag
    function showGetPublisherTag() {
        getPublisherTag().then(handleshowGetPublisherTag)
    }
    const handleshowGetPublisherTag = async (response) => {
        setgetPublisherTag(response.data);
    }

    const handleChangeOtherSeries = (event) => {
        setOtherSeries(event.target.value);
    }

    //getEbookSerie
    function showgetEbookSerie() {
        getEbookSerie().then(handleshowgetEbookSerie)
    }
    const handleshowgetEbookSerie = async (response) => {
        setgetEbookSerie(response.data);
    }

    useEffect(() => {
        window.scrollTo(0, 0);
        if (ebookDetailsID !== null && ebookDetailsID !== undefined) {
            setPublishOption('as_review_pass');
            setPricingAndSales('for_sale');
            showEbookPrice();
            showEbookCategory();
            showEbookDetails();
            setOnlyOver('0');
            showGetPublisherKeyword();
            showGetPublisherTag();
            showgetEbookSerie();
        }else{
            navigate('/ManageBooks', { replace: true });
        }
    }, []);

    const handleReader = (event) => {
        setTypeReader(event.target.value);
    };

    const handleShowEbookDetails = async (response) => {
        if(response != null && response.data.length > 0 && response.data[0] !== undefined){
                //ถ้ามาเป็น 9 คือราคา free จะไม่มีใน list ให้เลือก จึงต้องทำให้เป็นว่างเหมือนไม่ได้เลือกอยู่
            var ebookDetail = response.data[0];
            if(ebookDetail["ebook_price_id"] === 9){
                ebookDetail["ebook_price_id"] = ''
            }

            const readingMode = ebookDetail['reading_mode'];
            if(readingMode === 'ltr'){
                setRightToLeft('0');
            
            }else{
                setRightToLeft('1');
        
            }
            
            setgetEbookDetails(ebookDetail);
            
            const serieId = ebookDetail['serie_id'];
            setOtherSeries(serieId);

            setOnlyOver(ebookDetail['for_age_18_plus']);
        

            if (ebookDetail['sale_type'] === 'for_sale') {
                setPricingAndSales('for_sale');
            } else {
                setPricingAndSales('free');
            }
            
            setPublishOption(ebookDetail['publish_options']);
            setTypeReader(ebookDetail['reading_orientation']);

            //
            //TODO เช็คค่าว่าง
            if (ebookDetail['cover_image_path'] == null || ebookDetail['cover_image_path'] == '') {
                setUploadEBook('');
            } else {
                let ebookCoverImagePath = accessPath + ebookDetail['cover_image_path'];
                setUploadEBook(ebookCoverImagePath);
            }

            if (ebookDetail['uploaded_pdf_path'] == null || ebookDetail['uploaded_pdf_path'] == '') {
                setSelectedPdf(null);
            } else {
                let ebookPDFPath = accessPath + ebookDetail['uploaded_pdf_path'];
                setSelectedPdf(ebookPDFPath);
            }

            if (ebookDetail['epub_uploaded'] !== null && ebookDetail['epub_uploaded'] === "1") {
                let ebookPDFPath = ebookDetail['epub_uploaded']; // แค่ set ให้มันมีค่าก็พอ ไม่ต้องใช้ path จริงก็ได้
                setSelectedEpub(ebookPDFPath);
            } else {
                setSelectedEpub(null);
            }

            if (ebookDetail['epub_sample_available'] !== null && ebookDetail['epub_sample_available'] === "1") {
                let ebookPDFPath = ebookDetail['epub_sample_available']; // แค่ set ให้มันมีค่าก็พอ ไม่ต้องใช้ path จริงก็ได้
                setSelectedSampleEpub(ebookPDFPath);
            } else {
                setSelectedSampleEpub(null);
            }

            if(ebookDetail['publish_date'] != null ){
                setSelectedPublishDateTime(dayjs(ebookDetail['publish_date']))
            }
        
            const showKeywords = ebookDetail['keywords'];
            const showTags = ebookDetail['tags'];

            setKeywordsFromString(showKeywords);
            setTagsFromString(showTags);
        }else{
            navigate('/', { replace: true });
        }
    }

    const setKeywordsFromString = (str) => {
        if (str != '' && str != null) {
            const keywordsArray = str.split(',');
            setKeywords(keywordsArray);
        }
    };

    const setTagsFromString = (str) => {
        if (str != '' && str != null) {
            const TagsArray = str.split(',');
            setTags(TagsArray);
        }
    };

    const setKeywordsItem = (keyword) => {

        if (keyword !== '' && keyword != null) {
            if (!Keywords.includes(keyword)) {
                setKeywords((prevKeywords) => [...prevKeywords, keyword]);
            }
        }
    };

    const setTagsItem = (Tags) => {
        if (Tags !== '' && Tags != null) {
            if (!tags.includes(Tags)) {
                setTags((prevKeywords) => [...prevKeywords, Tags]);
            }
        }
    };

    const [formData, setFormData] = useState('');
    const [validated, setValidated] = useState(false);

    // Helper function to check if existing files are present in database
    // Takes into account files that user has deleted (treats them as non-existent)
    const hasExistingFiles = () => {
        const hasExistingPdf = (datagetEbookDetails['uploaded_pdf_path'] != null && datagetEbookDetails['uploaded_pdf_path'] !== '') && !deletedPdf;
        const hasExistingEpub = (datagetEbookDetails['epub_uploaded'] === "1") && !deletedEpub;
        const hasExistingEpubSample = (datagetEbookDetails['epub_sample_available'] === "1") && !deletedSampleEpub;
        
        return {
            pdf: hasExistingPdf,
            epub: hasExistingEpub,
            epubSample: hasExistingEpubSample
        };
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        // Check for newly selected files
        const hasNewPdf = selectedPdfName !== null;
        const hasNewEpub = selectedEpubName !== null;
        const hasNewSampleEpub = selectedSampleEpubName !== null;

        // Check for existing files in database
        const existingFiles = hasExistingFiles();

        // Combined availability: either new files or existing files
        const hasPdf = hasNewPdf || existingFiles.pdf;
        const hasEpub = hasNewEpub || existingFiles.epub;
        const hasSampleEpub = hasNewSampleEpub || existingFiles.epubSample;

        // Validation Rule 1: At least one file type (PDF or EPUB) must be available (new or existing)
        if (!hasPdf && !hasEpub) {
            dispatch(dialogConfirmSetData({
                title: "Validation Error",
                message: "Please select at least one file type: PDF or EPUB.",
                closeButton: "",
                confirmButton: "OK",
                eventConfirmButton: () => null,
                eventCloseButton: () => null,
                showCloseButton: false
            }));
            dispatch(dialogConfirmSetShowModal(true));
            return;
        }

        // Validation Rule 2: If EPUB sample is available (new or existing), EPUB must be available (new or existing)
        if (hasSampleEpub && !hasEpub) {
            dispatch(dialogConfirmSetData({
                title: "Validation Error",
                message: "EPUB file is required when EPUB sample file is selected.",
                closeButton: "",
                confirmButton: "OK",
                eventConfirmButton: () => null,
                eventCloseButton: () => null,
                showCloseButton: false
            }));
            dispatch(dialogConfirmSetShowModal(true));
            return;
        }

        //#####Upload E-Book Cover
        //uploadEBookName
        const bookTitle = formData.bookTitle || datagetEbookDetails['book_title'];
        const authorName = formData.authorName || datagetEbookDetails['book_author'];
        const category = formData.cateGory || datagetEbookDetails['ebook_category_id'];
        //otherSeries
        const otherSeriesName = formData.otherSeriesName || null;
        const volume = formData.volume || datagetEbookDetails['volume'];
        //selectedOnlyOver
        const synopsis = refSynopsis.current.value;
        const bookType = formData.bookType || datagetEbookDetails['book_type'];

        // const isbn = formData.isbn || datagetEbookDetails['isbn_number'];
        // const isbnEbook = formData.isbnEbook || datagetEbookDetails['isbn_ebook_number'];
        const isbn = refIsbn.current.value;
        const isbnEbook = refIsbnEbook.current.value;
        //tags
        //Keywords


        //####Pricing and Sales
        //PricingAndSales
        const paperCoverPrice = formData.paperCoverPrice || datagetEbookDetails['cover_price'] || '';
        const paperBookPrice = formData.paperBookPrice || datagetEbookDetails['ebook_price_id'] || '9';
        //selectedPdfName


        //####Status
        //const publicDate = formData.publicDate || datagetEbookDetails['publish_date'];

        let publicDate = null;
        const timestamp = selectedPublishDateTime || datagetEbookDetails['publish_date'] || null;
        if(publishOption == 'schedule'){
            const date = new Date(timestamp);
            publicDate = `${date.getFullYear()}/${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getDate().toString().padStart(2, '0')} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`; 
        }

        const noteTeam = refNote.current.value;

        const _getPublisher = async () => {
            try {
                const response = await getPublisher();
                // console.log('xxxx' + response.data['result']['publisherID']);
                return response.data['result']['publisherID'];
            } catch (error) {
                // console.error("Error while getting publisher:", error);
                // Handle the error or return a default value
                return '';
            }
        };

        const form = event.currentTarget;
        if (form.checkValidity() === true) {
            setCheckButtonLoading('2');
            event.preventDefault();
            event.stopPropagation();

            let publisherId = "";

            let getPublisherResult = await _getPublisher();
            publisherId = getPublisherResult;

            // Information about newly selected files for upload process
            const newFileInfo = {
                hasNewPdf,
                hasNewEpub,
                hasNewSampleEpub,
                hasNewCoverImage: selectedFileCoverImage !== null
            };

            editEbookDetails(
                uploadEBookName, bookTitle, authorName, category, otherSeries, otherSeriesName, selectedOnlyOver, synopsis, bookType, isbn, isbnEbook, tags, Keywords,
                PricingAndSales, paperCoverPrice, paperBookPrice,
                publishOption, publicDate, noteTeam, ebookDetailsID, volume ,rightToLeft , typeReader
            ).then((response) => handleAfterInsertEbook(response, publisherId, newFileInfo));

        } else {

        }
        setValidated(true);
    }




    async function handleAfterInsertEbook(response, publisherId, newFileInfo) {

        // Check if any new files need to be uploaded
        const hasAnyNewFiles = newFileInfo.hasNewCoverImage || newFileInfo.hasNewPdf || newFileInfo.hasNewEpub || newFileInfo.hasNewSampleEpub;
        const hasAnyDeletedFiles = deletedPdf || deletedEpub || deletedSampleEpub;
        let uploadResult;
        if (hasAnyNewFiles || hasAnyDeletedFiles) {
            // Only perform upload if there are new files
            uploadResult = await uploadBookResource(publisherId, newFileInfo);
        } else {
            // No new files to upload, create a successful result
            uploadResult = {
                "isUploadPdfError": false,
                "isUploadImageError": false,
                "isUploadEpubError": false,
                "isUploadEpubSampleError": false
            };
        }

        if (uploadResult['isUploadImageError'] == true && uploadResult['isUploadPdfError'] == true) {
            setCheckButtonLoading('1');
            setUploadImageErrorMessage(uploadResult['uploadImageErrorMessage']);
            setUploadPdfErrorMessage(uploadResult['uploadPdfErrorMessage']);
            setUploadEBook('');
            // setShowAlertError(true);

            // const result = window.confirm(uploadResult['uploadImageErrorMessage'] + '\n' + uploadResult['uploadPdfErrorMessage']);
            dispatch(dialogConfirmSetData({
                title: "Error",
                message: uploadResult['uploadImageErrorMessage'] +  " \n " + uploadResult['uploadPdfErrorMessage'],
                closeButton: "",
                confirmButton: "OK",
                eventConfirmButton: () => null,
                eventCloseButton: () => null,
                showCloseButton: false
            }));
            // ** ทำให้ dialog โชว์ขึ้นมา **
            dispatch(dialogConfirmSetShowModal(true));
        }
        else if (uploadResult['isUploadImageError'] == true) {
            setCheckButtonLoading('1');
            setUploadImageErrorMessage(uploadResult['uploadImageErrorMessage']);
            setUploadPdfErrorMessage('');
            setUploadEBook('');
            // setShowAlertError(true);
            dispatch(dialogConfirmSetData({
                title: "Error",
                message: uploadResult['uploadImageErrorMessage'],
                closeButton: "",
                confirmButton: "OK",
                eventConfirmButton: () => null,
                eventCloseButton: () => null,
                showCloseButton: false
            }));
            // ** ทำให้ dialog โชว์ขึ้นมา **
            dispatch(dialogConfirmSetShowModal(true));
        }
        else if (uploadResult['isUploadPdfError'] == true) {
            setCheckButtonLoading('1');

            setUploadPdfErrorMessage(uploadResult['uploadPdfErrorMessage']);
            setUploadImageErrorMessage('');
            setSelectedPdf(null);
            // setShowAlertError(true);
            dispatch(dialogConfirmSetData({
                title: "Error",
                message: uploadResult['uploadPdfErrorMessage'],
                closeButton: "",
                confirmButton: "OK",
                eventConfirmButton: () => null,
                eventCloseButton: () => null,
                showCloseButton: false
            }));
            // ** ทำให้ dialog โชว์ขึ้นมา **
            dispatch(dialogConfirmSetShowModal(true));
        } else {
            goToViewEbookPage();
        }
    }

    function goToViewEbookPage(){
        navigate('/ViewEbooks', {
            replace: true,
            state: {
                ebookDetailsID: ebookDetailsID,
                bookTitle: formData.bookTitle,
                searchKeyword : searchKeyword , 
                searchOption : searchOption
            }
        });
    }

    async function uploadBookResource(publisherId, newFileInfo) {

        var uploadCoverImagePath = null;
        var uploadSamplePdfPath = null;
        var uploadMainPdfPath = null;

        var isUploadCoverError = false;
        var uploadCoverErrorMessage = "";

        var isUploadPdfError = false;
        var uploadPdfErrorMessage = "";

        var isUploadEpubError = false;
        var uploadEpubErrorMessage = "";

        var isUploadEpubSampleError = false;
        var uploadEpubSampleErrorMessage = "";

        // Only upload cover image if a new one was selected
        if (newFileInfo.hasNewCoverImage && selectedFileCoverImage !== null) {
            // console.log("before image cover : ");
            const uploadFilePromise = uploadFileEbook(selectedFileCoverImage, ebookDetailsID, publisherId)
                .then(async response => {
                    if (response.data['access_path'] != null && response.data['error'] !== true) {
                        uploadCoverImagePath = response.data['access_path'];
                        await updateEbookCoverPath(uploadCoverImagePath, ebookDetailsID);
                    } else {
                        isUploadCoverError = true;
                        uploadCoverErrorMessage = "We're sorry, but it looks like there's an issue with the file you uploaded. Please ensure you're uploading a valid file with the correct format";
                    }

                });

            await Promise.all([uploadFilePromise]);

        }

        // Only upload PDF if a new one was selected
        if (newFileInfo.hasNewPdf && selectedPdfName !== null) {
            const uploadPdfPromise = uploadPdfEbook(selectedPdfName, ebookDetailsID, publisherId)
                .then(async response => {
                    if (response.data['error'] === false) {
                        uploadSamplePdfPath = "uploaded";
                        uploadMainPdfPath = "uploaded";

                        await updateEbookPDFPath(uploadMainPdfPath, uploadSamplePdfPath, ebookDetailsID).then(response => {
                            // console.log(response.data);
                        });

                    } else {
                        isUploadPdfError = true;
                        uploadPdfErrorMessage = "We're sorry, but it looks like there's an issue with the file you uploaded. Please ensure you're uploading a valid file with the correct format";
                    }
                });

            // console.log("start pdf upload");
            await Promise.all([uploadPdfPromise]);
            // console.log("end pdf upload");
        }else{
            if(deletedPdf){
                await updateEbookPDFPath(null, null, ebookDetailsID, 0);
            }
        }

        // Only upload EPUB if a new one was selected
        // ต้อง upload pdf ด้วยเท่านั้นถึงจะ
        if(newFileInfo.hasNewEpub && selectedEpubName !== null) {
            const uploadEpubPromise = uploadEpubEbook(selectedEpubName, ebookDetailsID, publisherId)
                .then(async response => {
                    var uploadStatus = true;
                    if (response.data['error'] === false) {
                        uploadStatus = true;
                    }else{
                        uploadStatus = false;
                        isUploadEpubError = true;
                        uploadEpubErrorMessage = "We're sorry, but it looks like there's an issue with the file you uploaded. Please ensure you're uploading a valid file with the correct format";
                    }
                    await updateEbookEpubFileStatus(uploadStatus, ebookDetailsID);
                });

            await Promise.all([uploadEpubPromise]);
        }else{
            if(deletedEpub){
                await updateEbookEpubFileStatus(false, ebookDetailsID);
            }
        }

        // Only upload sample EPUB if a new one was selected
        if(newFileInfo.hasNewSampleEpub && selectedSampleEpubName !== null) {
            const uploadEpubSamplePromise = uploadEpubSampleEbook(selectedSampleEpubName, ebookDetailsID, publisherId)
                .then(async response => {
                    var uploadStatus = true;
                    if (response.data['error'] === false) {
                        uploadStatus = true;
                    }else{
                        uploadStatus = false;
                        isUploadEpubSampleError = true;
                        uploadEpubSampleErrorMessage = "We're sorry, but it looks like there's an issue with the file you uploaded. Please ensure you're uploading a valid file with the correct format";
                    }
                    await updateEbookEpubSampleFileStatus(uploadStatus, ebookDetailsID);
                    
                });
            await Promise.all([uploadEpubSamplePromise]);
        }else{
            if(deletedSampleEpub){
                await updateEbookEpubSampleFileStatus(false, ebookDetailsID);
            }
        }

        if(isUploadPdfError || isUploadCoverError || isUploadEpubError || isUploadEpubSampleError) {

            let result = {
                "isUploadPdfError": isUploadPdfError,
                "isUploadImageError": isUploadCoverError,
                "isUploadEpubError": isUploadEpubError,
                "isUploadEpubSampleError": isUploadEpubSampleError,
                "uploadPdfErrorMessage": uploadPdfErrorMessage,
                "uploadImageErrorMessage": uploadCoverErrorMessage,
                "uploadEpubErrorMessage": uploadEpubErrorMessage,
                "uploadEpubSampleErrorMessage": uploadEpubSampleErrorMessage
            };

            return result;
        } else {

            let result = {
                "isUploadPdfError": false,
                "isUploadImageError": false,
                "isUploadEpubError": false,
                "isUploadEpubSampleError": false
            };
            return result;
        }
    }

    const deleteFilePdf = () => {

        dispatch(dialogConfirmSetData({
            title: "Confirm clear",
            message: "This will remove the selected file from the upload.",
            closeButton: "Cancel",
            confirmButton: "Remove",
            eventConfirmButton: () => {
                setSelectedPdf(null);
                setDeletedPdf(true); // Mark PDF as deleted
            },
            eventCloseButton: () => null,
            showCloseButton: true
        }));
        // ** ทำให้ dialog โชว์ขึ้นมา **
        dispatch(dialogConfirmSetShowModal(true));
    }

    const deleteFileEpub = () => {
        dispatch(dialogConfirmSetData({
            title: "Confirm clear",
            message: "This will remove the selected file from the upload.",
            closeButton: "Cancel",
            confirmButton: "Remove",
            eventConfirmButton: () => {
                setSelectedEpub(null);
                setDeletedEpub(true); // Mark EPUB as deleted
            },
            eventCloseButton: () => null,
            showCloseButton: true
        }));
        // ** ทำให้ dialog โชว์ขึ้นมา **
        dispatch(dialogConfirmSetShowModal(true));
    }

    const deleteFileSampleEpub = () => {
        dispatch(dialogConfirmSetData({
            title: "Confirm clear",
            message: "This will remove the selected file from the upload.",
            closeButton: "Cancel",
            confirmButton: "Remove",
            eventConfirmButton: () => {
                setSelectedSampleEpub(null);
                setDeletedSampleEpub(true); // Mark sample EPUB as deleted
            },
            eventCloseButton: () => null,
            showCloseButton: true
        }));
        // ** ทำให้ dialog โชว์ขึ้นมา **
        dispatch(dialogConfirmSetShowModal(true));
    }

    const deleteProFileCover = () => {
        dispatch(dialogConfirmSetData({
            title: "Confirm clear",
            message: "This will remove the selected file from the upload.",
            closeButton: "Cancel",
            confirmButton: "Remove",
            eventConfirmButton: () => setUploadEBook(""),
            eventCloseButton: () => null,
            showCloseButton: true
        }));
        // ** ทำให้ dialog โชว์ขึ้นมา **
        dispatch(dialogConfirmSetShowModal(true));
    }

    return (
        <div >
            <Head />
            <Row className='row-navbar'>
                <NavBar />
                <Col className='row-context' >
                    <main>

                        <div className='box-context'>
                            <span className='title-text'> <div className='title-content-text' onClick={() => handleBackClick()}>Manage Books</div><div style={{marginLeft: '10px',marginRight: '10px'}}>{'›'}</div> Edit E-books   </span>
                            <p className='context-text'>Edit your E-Book.</p>

                            <Card className='card-box card-box-top-pading'>
                                <Card.Body>
                                    <div className='content-box'>
                                        <span className='inner-title-text'>Book Details</span>
                                        <hr className='hr-title' />
                                        <Form noValidate validated={validated} onSubmit={handleSubmit}>

                                            <Form.Group as={Row} className="mb-12" controlId="">
                                                <Form.Label column sm="4">
                                                    <div style={{ paddingBottom: '0px' }}>
                                                        <span className='my-rowlabel'>Upload E-Book Cover<span className='star' >*</span></span>
                                                    </div>
                                                </Form.Label>
                                                <Col sm="6" style={{ paddingTop: '10px' }}>
                                                    {(uploadEBook) ?
                                                        <div>
                                                            <div className="image-frame" >
                                                                <ImageWithPlaceholder
                                                                    src={uploadEBook}
                                                                    placeholder={placeholderImg}
                                                                    className = 'book-overview'
                                                                />                    
                                                            </div>
                                                            <div>
                                                                <span className='text-alerts' ></span>
                                                            </div>
                                                            <a onClick={() => deleteProFileCover()}className='delete-link link-button'>Delete</a>
                                                        </div>
                                                        :
                                                        <div>
                                                            <Form.Control ref={uploadImageRef} required type="file" accept="image/jpeg" value={formData.uploadEBook} name="uploadEBook" onChange={handleImageChange} />
                                                            <div>
                                                                <span className='text-alerts' >Supported file extensions .jpg .jpeg Only</span>
                                                            </div>
                                                        </div>
                                                    }

                                                </Col>
                                            </Form.Group>

                                            <br></br>

                                            <Form.Group as={Row} className="mb-3" controlId="">
                                                <Form.Label column sm="4">
                                                    Book Title <span className='star' >*</span>
                                                </Form.Label>
                                                <Col sm="6">
                                                    <Form.Control required type="text" maxLength={200} defaultValue={formData.bookTitle || datagetEbookDetails['book_title']} name="bookTitle" onChange={handleChange} />
                                                </Col>
                                            </Form.Group>

                                            <Form.Group as={Row} className="mb-3" controlId="">
                                                <Form.Label column sm="4">
                                                    Author Name <span className='star' >*</span>
                                                </Form.Label>
                                                <Col sm="6">
                                                    <Form.Control required type="text" defaultValue={formData.authorName || datagetEbookDetails['book_author']} name="authorName" onChange={handleChange} />
                                                </Col>
                                            </Form.Group>

                                            <Form.Group as={Row} className="mb-3" controlId="">
                                                <Form.Label column sm="4">
                                                    Category <span className='star' >*</span>
                                                </Form.Label>
                                                <Col sm="6">
                                                    <Form.Select required value={formData.cateGory || datagetEbookDetails['ebook_category_id']} name="cateGory" onChange={handleChange}>
                                                        <option value=''>Please Select</option>
                                                        {optionsgetEbookCategory.map((option) => (
                                                            <option key={option.id} value={option.id}>
                                                                {option.name_th}
                                                            </option>
                                                        ))}
                                                    </Form.Select>
                                                </Col>
                                            </Form.Group>

                                            <Form.Group as={Row} className="mb-3" controlId="">
                                                <Form.Label column sm="4">
                                                    Book Series <span className='star' >*</span>
                                                </Form.Label>
                                                <Col sm="6">
                                                    <Form.Select required value={otherSeries} name="otherSeries" onChange={handleChangeOtherSeries}>
                                                        <option value='0' >Other Series</option>
                                                        {getEbookSeries.map((option) => (
                                                            <option key={option.serie_id} value={option.serie_id}>
                                                                {option.serie_name}
                                                            </option>
                                                        ))}
                                                    </Form.Select>

                                                </Col>
                                            </Form.Group>

                                            {otherSeries === '0' && (
                                                <div>
                                                    <Form.Group as={Row} className="mb-3" controlId="">
                                                        <Form.Label column sm="4">
                                                        </Form.Label>
                                                        <Col sm="6">

                                                            <Form.Control required aria-label="New Book series" maxLength={100}  placeholder="New Book series" type="text" value={formData.otherSeriesName} name="otherSeriesName" onChange={handleChange} />
                                                        </Col>
                                                    </Form.Group>
                                                </div>
                                            )}

                                            <Form.Group as={Row} className="mb-3" controlId="">
                                                <Form.Label column sm="4">
                                                </Form.Label>
                                                <Col sm="6">
                                                    <Form.Control required aria-label="Order of books in this series" placeholder="Order of books in this series" type="number" min={1} defaultValue={formData.volume || datagetEbookDetails['volume']} name="volume" onChange={handleChange} />
                                                    <span className='text-alerts' >Order of books in this series</span>
                                                </Col>
                                            </Form.Group>


                                            <Form.Group as={Row} className="mb-3" controlId="">
                                                <Form.Label column sm="4">
                                                    Only for People Over 18 Years Old
                                                </Form.Label>
                                                <Col sm="6">

                                                    <Form.Check
                                                        label="Yes"
                                                        type='checkbox'
                                                        name='onlyOver'
                                                        value='1'
                                                        //checked={selectedOnlyOver === '1'}
                                                        onChange={handleChangeOnlyOver}
                                                        inline
                                                        checked={selectedOnlyOver === '1'}
                                                    />
                                                </Col>
                                            </Form.Group>


                                            <Form.Group as={Row} className="mb-3" controlId="">
                                                <Form.Label column sm="4">
                                                    Synopsis
                                                </Form.Label>
                                                <Col sm="6">
                                                    <Form.Control
                                                        defaultValue={datagetEbookDetails['book_description']}
                                                        name="synopsis"
                                                        ref={refSynopsis}
                                                        onChange={handleChange}
                                                        as="textarea"
                                                        placeholder=""
                                                        style={{ height: '100px' }}
                                                    />
                                                </Col>
                                            </Form.Group>


                                            <Form.Group as={Row} className="mb-3" controlId="">
                                                <Form.Label column sm="4">
                                                    Book Type <span className='star' >*</span>
                                                </Form.Label>
                                                <Col sm="6">
                                                    <Form.Select required value={formData.bookType || datagetEbookDetails['book_type']} name="bookType" onChange={handleChange} >
                                                        <option value=''>Please Select</option>
                                                        <option value="1" >Thai Book</option>
                                                        <option value="2" >Translated Book</option>

                                                    </Form.Select>

                                                </Col>
                                            </Form.Group>

                                            <Form.Group as={Row} className="mb-3" controlId="">
                                                <Form.Label column sm="4">
                                                    ISBN
                                                </Form.Label>
                                                <Col sm="6">
                                                    <Form.Control type="text"  maxLength={30}  ref={refIsbn} defaultValue={formData.isbn || datagetEbookDetails['isbn_number']} name="isbn" onChange={handleChange} />
                                                </Col>
                                            </Form.Group>

                                            <Form.Group as={Row} className="mb-3" controlId="">
                                                <Form.Label column sm="4">
                                                    ISBN E-Book
                                                </Form.Label>
                                                <Col sm="6">
                                                    <Form.Control type="text" maxLength={30}  ref={refIsbnEbook} defaultValue={formData.isbnEbook || datagetEbookDetails['isbn_ebook_number']} name="isbnEbook" onChange={handleChange} />
                                                </Col>
                                            </Form.Group>

                                            <Form.Group as={Row} className="mb-3" controlId="">
                                                <Form.Label column sm="4">
                                                                Right-to-left reading style
                                                </Form.Label>
                                                <Col sm="6">

                                                    <Form.Check
                                                        label="Yes"
                                                        type='checkbox'
                                                        name='rightToLeft'
                                                        value='1'
                                                        onChange={handleChangeRightToLeft}
                                                        inline
                                                        checked={rightToLeft === '1'}
                                                    />
                                    
                                                </Col>
                                            </Form.Group>

                                            <Form.Group as={Row} className="mb-3" controlId="">
                                                <Form.Label column sm="4">
                                                  Reading Direction 
                                                </Form.Label>
                                                <Col sm="6">
                                                <Form.Check
                                                        label="Horizontal and Vertical Scrolling"
                                                        type='radio'
                                                        name='reader'
                                                        value='both'
                                                        onChange={handleReader}
                                                        inline
                                                        checked={typeReader === 'both'}
                                                    />

                                                    <Form.Check
                                                        label="Vertical Scrolling only"
                                                        type='radio'
                                                        name='reader'
                                                        value='vertical'
                                                        onChange={handleReader}
                                                        inline
                                                        checked={typeReader === 'vertical'}
                                                    />

                                                
                                                </Col>
                                            </Form.Group>


                                            <Form.Group as={Row} className="mb-3" controlId="">
                                                <Form.Label column sm="4">
                                                    Tags
                                                </Form.Label>
                                                <Col sm="6" style={{ border: '1px solid #ced4da', borderRadius: '6px', marginLeft: '10px', width: '48.5%', paddingTop: '10px' }}>
                                                    <TagsInput className='input-tag-custom' required value={tags || datagetEbookDetails['tags']} onChange={handleTagsChange} addOnBlur={true} addOnPaste={true} onlyUnique={true} />

                                                </Col>

                                            </Form.Group>

                                            <Form.Group as={Row} className="mb-3" controlId="">
                                                <Form.Label column sm="4">
                                                </Form.Label>
                                                <Col sm="6">
                                                    <div style={{ display: 'flex', gap: '5px', flexWrap: 'wrap' }} className='div-my-button'>
                                                        {getPublisherTags.map((option) => (
                                                            !tags.includes(option.tag_name) ? (
                                                                <a
                                                                    key={option.tag_name}
                                                                    style={{ marginRight: '2px', color: '#fff' }}
                                                                    onClick={() => setTagsItem(option.tag_name)}
                                                                    className="my-button"
                                                                >
                                                                    <span className='font-tags'>{option.tag_name} + </span>
                                                                </a>
                                                            ) : null
                                                        ))}
                                                    </div>
                                                </Col>
                                            </Form.Group>


                                            <Form.Group as={Row} className="mb-3" controlId="">
                                                <Form.Label column sm="4">
                                                    Keywords
                                                </Form.Label>
                                                <Col sm="6" style={{ border: '1px solid #ced4da', borderRadius: '6px', marginLeft: '10px', width: '48.5%', paddingTop: '10px' }}>
                                                    <TagsInput className='input-keyword-custom' required value={Keywords || datagetEbookDetails['keywords']} onChange={handleKeywords} placeholder={customPlaceholder} addOnBlur={true} addOnPaste={true} onlyUnique={true} inputProps={{ placeholder: customPlaceholder }} />

                                                </Col>
                                            </Form.Group>
                                            <Form.Group as={Row} className="mb-3" controlId="">
                                                <Form.Label column sm="4">
                                                </Form.Label>
                                                <Col sm="6">
                                                    <div style={{ display: 'flex', gap: '5px', flexWrap: 'wrap' }} className='div-my-button'>
                                                        {getPublisherKeywords.map((option) => (
                                                            (!Keywords.includes(option.keyword_name)) ?
                                                                <a key={option.keyword_name} style={{ marginRight: '2px', color: '#fff' }} onClick={() => setKeywordsItem(option.keyword_name)} className="my-button-keyboard"> <span className='font-tags'>{option.keyword_name} + </span></a>
                                                                : <></>
                                                        ))}
                                                    </div>
                                                </Col>
                                            </Form.Group>


                                            <br></br>
                                            <span className='inner-title-text'>Pricing and Sales</span>
                                            <hr className='hr-title' />
                                            <Form.Group as={Row} className="mb-3" controlId="">
                                                <Form.Label column sm="4">
                                                    Type Sales <span className='star' >*</span>
                                                </Form.Label>
                                                <Col sm="6">
                                                    <Form.Check
                                                        label="Books for Sale"
                                                        type='radio'
                                                        name='PricingAndSales'
                                                        value='for_sale'
                                                        checked={PricingAndSales === 'for_sale'}
                                                        onChange={handlePricingAndSales}
                                                        inline


                                                    />

                                                    <Form.Check
                                                        label="Free Books"
                                                        type='radio'
                                                        name='PricingAndSales'
                                                        value='free'
                                                        checked={PricingAndSales === 'free'}
                                                        onChange={handlePricingAndSales}
                                                        inline

                                                    />
                                                </Col>
                                            </Form.Group>

                                            {PricingAndSales === 'for_sale' && (
                                                <div>
                                                    <Form.Group as={Row} className="mb-3" controlId="">
                                                        <Form.Label column sm="4">
                                                            Paper Cover Price  <span className='star' >*</span>
                                                        </Form.Label>
                                                        <Col sm="6">
                                                            <Form.Control required type="text" onKeyPress={(event) => { if (!/[0-9]/.test(event.key)) { event.preventDefault() } }}  min="0" isInvalid={!!CoverPriceError} defaultValue={formData.paperCoverPrice || datagetEbookDetails['cover_price']} name="paperCoverPrice" onChange={handleChange}>
                                                            </Form.Control>
                                                            <Form.Control.Feedback type="invalid">
                                                                {CoverPriceError}
                                                            </Form.Control.Feedback>
                                                        </Col>
                                                    </Form.Group>

                                                    <Form.Group as={Row} className="mb-3" controlId="">
                                                        <Form.Label column sm="4">
                                                            Book Price  <span className='star' >*</span>
                                                        </Form.Label>
                                                        <Col sm="6">
                                                            <Form.Select required value={formData.paperBookPrice || datagetEbookDetails['ebook_price_id']} name="paperBookPrice" onChange={handleChange}>
                                                                <option value=''>Please Select</option>
                                                                {optionsgetEbookPrice.map((option) => (
                                                                    <option key={option.id} value={option.id}>
                                                                        {option.price}
                                                                    </option>
                                                                ))}
                                                            </Form.Select>
                                                        </Col>
                                                    </Form.Group>


                                                </div>
                                            )}

                                            <br></br>
                                            <span className='inner-title-text'>E-Book File</span>
                                            <hr className='hr-title' />

                                            <Form.Group as={Row} className="mb-3" controlId="">

                                                <Form.Label column sm="4">
                                                    <div>
                                                        <span className='my-rowlabel'>Upload E-Book File</span>
                                                    </div>
                                                </Form.Label>
                                                <Col sm="6">
                                                    {(selectedPdf) ?
                                                        <div >
                                                            <Form.Label column sm="4">There is a file uploaded</Form.Label>
                                                            <a onClick={() => deleteFilePdf()} className='delete-link link-button'>Delete</a>
                                                        </div>
                                                        :
                                                        <div>
                                                            <Form.Control ref={uploadPDFRef} type="file" accept=".pdf" onChange={handlePdfChange} />
                                                            <div>
                                                                <span className='text-alerts' >Supported file extension .pdf only</span>
                                                            </div>
                                                        </div>
                                                    }
                                                </Col>
                                            </Form.Group>

                                            <Form.Group as={Row} className="mb-3" controlId="">

                                                <Form.Label column sm="4">
                                                    <div >
                                                        <span className='my-rowlabel'>Upload Epub File</span>
                                                    </div>
                                                </Form.Label>
                                                <Col sm="6">
                                                    {(selectedEpub) ?
                                                        <div >
                                                             <Form.Label column sm="4">
                                                               There is a file uploaded
                                                                 </Form.Label>
                                                            <a onClick={() => deleteFileEpub()} className='delete-link link-button'>Delete</a>
                                                        </div>
                                                        :
                                                        <div>
                                                            <Form.Control ref={uploadEpubRef} type="file" accept=".epub" onChange={handleEpubChange} />
                                                            <div>
                                                                <span className='text-alerts' >Supported file extensions: .epub only</span>
                                                            </div>
                                                        </div>
                                                    }
                                                </Col>
                                            </Form.Group>

                                            <Form.Group as={Row} className="mb-3" controlId="">

                                                <Form.Label column sm="4">
                                                    <div >
                                                        <span className='my-rowlabel'>Upload Sample Epub File</span>
                                                    </div>
                                                </Form.Label>
                                                <Col sm="6">
                                                    {(selectedSampleEpub) ?
                                                        <div >
                                                             <Form.Label column sm="4">
                                                               There is a file uploaded
                                                                 </Form.Label>
                                                            <a onClick={() => deleteFileSampleEpub()} className='delete-link link-button'>Delete</a>
                                                        </div>
                                                        :
                                                        <div>
                                                            <Form.Control ref={uploadSampleEpubRef} type="file" accept=".epub" onChange={handleSampleEpubChange} />
                                                            <div>
                                                                <span className='text-alerts' >Supported file extensions: .epub only</span>
                                                            </div>
                                                        </div>
                                                    }
                                                </Col>
                                            </Form.Group>
                                            <br></br>

                                            <span className='inner-title-text'>On-sale date</span>
                                            <hr className='hr-title' />
                                            <Form.Group as={Row} className="mb-12" controlId="">
                                                <Form.Label column sm="4">
                                                    <span className='my-rowlabel'>Status<span className='star' >*</span></span>
                                                </Form.Label>
                                                <Col >
                                                    <Form.Check
                                                        label="As soon as review pass"
                                                        type='radio'
                                                        name='publishOption'
                                                        value='as_review_pass'
                                                        checked={publishOption === 'as_review_pass'}
                                                        onChange={handleStatus}
                                                        inline

                                                    />

                                                    <Form.Check
                                                        label="Scheduled"
                                                        type='radio'
                                                        name='publishOption'
                                                        value='schedule'
                                                        checked={publishOption === 'schedule'}
                                                        onChange={handleStatus}
                                                        inline

                                                    />
                                                </Col>
                                            </Form.Group>
                                            <div style={{ paddingTop: '10px' }}></div>

                                            {publishOption === 'schedule' && (
                                                <div>
                                                    <Form.Group as={Row} className="mb-3" controlId="">
                                                        <Form.Label column sm="4">
                                                            Publish Date <span className='star' >*</span>
                                                        </Form.Label>
                                                        <Col sm="6" className='date-time-input'>
                                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                <DemoContainer components={['DateTimePicker']}>
                                                                {selectedPublishDateTime && (
                                                                    <DateTimePicker
                                                                        isBeforeDay={true}
                                                                        onChange={handleDateChange}
                                                                        format="DD/MM/YYYY HH:mm"
                                                                        ampm={false}
                                                                        value={selectedPublishDateTime || dayjs()}
                                                                    />
                                                                    )}
                                                                </DemoContainer>
                                                            </LocalizationProvider>
                                                        </Col>
                                                    </Form.Group>
                                                </div>
                                            )}

                                            <Form.Group as={Row} className="mb-3" controlId="">
                                                <Form.Label column sm="4">
                                                Note to Reviewers
                                                </Form.Label>
                                                <Col sm="6">
                                                    <Form.Control as="textarea" rows="3" maxLength="300" isInvalid={!!textareaError} ref={refNote} defaultValue={datagetEbookDetails['notes']} name="noteTeam" onChange={handleChange} />
                                                </Col>
                                            </Form.Group>

                                            <br></br>

                                            <center>
                                                <div>
                                                    {showAlertError && (
                                                        <Alert variant="danger" onClose={() => setShowAlertError(false)} dismissible>
                                                            <Alert.Heading>Error</Alert.Heading>
                                                            <p>
                                                                {showUploadImageErrorMessage + showUploadPdfErrorMessage}
                                                            </p>
                                                        </Alert>
                                                    )}
                                                </div>

                                                <br></br>

                                                {checkButtonLoading == '1' && (
                                                    <Button className='button-form-cancel button-main button-white' onClick={goToViewEbookPage} variant="primary">Cancel</Button>
                                                )}

                                                {checkButtonLoading == 1 && (
                                                    <Button className='button-form-save button-main button-orange' variant="primary" type="submit">Save</Button>
                                                )}

                                                {checkButtonLoading == 2 && (
                                                    <Spinner animation="border" role="status">
                                                        <span className="visually-hidden">Loading...</span>
                                                    </Spinner>
                                                )}
                                            </center>
                                        </Form>
                                    </div>
                                </Card.Body>
                            </Card>
                        </div>
                    </main>
                </Col>
            </Row>
        </div >
    );
};

export default EditEbooks;
